const Url = {
  getToken: '/get-user-token-details',
  getContent: '/content',
};
export default Url;
